export default __webpack_public_path__ + "static/media/automation.3403c6a9.jpg";